export default __webpack_public_path__ + "static/ogp-0ba49530b8b42247993fa177a290f1af.png";